/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Department } from './Department';
import { DepartmentFromJSON, DepartmentFromJSONTyped, DepartmentToJSON } from './Department';

/**
 *
 * @export
 * @interface PaginatedDepartmentList
 */
export interface PaginatedDepartmentList {
  /**
   *
   * @type {number}
   * @memberof PaginatedDepartmentList
   */
  count: number;
  /**
   *
   * @type {string}
   * @memberof PaginatedDepartmentList
   */
  next?: string | null;
  /**
   *
   * @type {string}
   * @memberof PaginatedDepartmentList
   */
  previous?: string | null;
  /**
   *
   * @type {Array<Department>}
   * @memberof PaginatedDepartmentList
   */
  results: Array<Department>;
}

/**
 * Check if a given object implements the PaginatedDepartmentList interface.
 */
export function instanceOfPaginatedDepartmentList(value: object): value is PaginatedDepartmentList {
  if (!('count' in value) || value['count'] === undefined) return false;
  if (!('results' in value) || value['results'] === undefined) return false;
  return true;
}

export function PaginatedDepartmentListFromJSON(json: any): PaginatedDepartmentList {
  return PaginatedDepartmentListFromJSONTyped(json, false);
}

export function PaginatedDepartmentListFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedDepartmentList {
  if (json == null) {
    return json;
  }
  return {
    count: json['count'],
    next: json['next'] == null ? undefined : json['next'],
    previous: json['previous'] == null ? undefined : json['previous'],
    results: (json['results'] as Array<any>).map(DepartmentFromJSON),
  };
}

export function PaginatedDepartmentListToJSON(value?: PaginatedDepartmentList | null): any {
  if (value == null) {
    return value;
  }
  return {
    count: value['count'],
    next: value['next'],
    previous: value['previous'],
    results: (value['results'] as Array<any>).map(DepartmentToJSON),
  };
}
